import { api } from './api';

/** Заказы поставщикам из Zoho Books (/api/purchase-orders). */
export type PoStatus = 'Draft' | 'Sent' | 'Confirmed' | 'ReadyForPickup' | 'PartiallyPickedUp' | 'PickedUp' | 'Closed' | 'Cancelled';
export type OrderRow = {
  id: string;
  poNumber: string;
  partnerId: string;
  partnerName: string | null;
  partnerPhone: string | null;
  vendorName: string | null;
  source: 'hub' | 'zoho';
  zohoStatus: string | null;
  fulfillmentStatus: PoStatus;
  paymentStatus: string;
  total: number;
  vatTotal: number;
  currency: string;
  orderedAt: string | null;
  expectedAt: string | null;
  sentAt: string | null;
  pickedUpAt: string | null;
  closedAt: string | null;
  lastSyncedAt: string | null;
  pickupAddress: string | null;
  lines: number;
  units: number;
  reference: string | null;
  billedStatus: string | null;
  receivedStatus: string | null;
  zohoUrl: string | null;
  items?: { id: string; sku: string | null; supplierArticle: string | null; name: string | null; qty: number; qtyReceived: number; unitCost: number; unit: string | null; total: number }[];
  meta?: Record<string, unknown>;
};
export type SyncRun = { id: number; status: 'running' | 'ok' | 'error'; startedAt: string; finishedAt: string | null; seen: number; imported: number; skipped: number; errors: { po?: string; error: string }[]; note: string | null };
export type OrdersPayload = { orders: OrderRow[]; summary: { byStatus: Record<string, { count: number; total: number }>; openValue: number; openCount: number; closedValue: number }; sync: SyncRun | null; zohoConfigured: boolean };
export type Arrival = { poNumber: string; sku: string | null; name: string | null; partnerName: string | null; qty: number; eta: string | null; image: string | null };

export const ordersApi = {
  list: (params: { status?: string; partnerId?: string; q?: string } = {}) => {
    const q = new URLSearchParams();
    if (params.status && params.status !== 'All') q.set('status', params.status);
    if (params.partnerId) q.set('partner_id', params.partnerId);
    if (params.q) q.set('q', params.q);
    const s = q.toString();
    return api.get<OrdersPayload>(`/purchase-orders${s ? `?${s}` : ''}`);
  },
  get: (poNumber: string) => api.get<OrderRow>(`/purchase-orders/${encodeURIComponent(poNumber)}`),
  arrivals: (weeks = 3) => api.get<Arrival[]>(`/purchase-orders/arrivals?weeks=${weeks}`),
  syncStatus: () => api.get<{ last: SyncRun | null; zohoConfigured: boolean; running: boolean }>('/purchase-orders/sync'),
  startSync: (months = 12, full = false) => api.post<{ started: boolean }>(`/purchase-orders/sync?months=${months}&full=${full}`),
};

export const OPEN_STATUSES: PoStatus[] = ['Draft', 'Sent', 'Confirmed', 'ReadyForPickup', 'PartiallyPickedUp'];

export const poTone = (status: string): 'primary' | 'secondary' | 'accent' | 'neutral' | 'danger' => {
  if (status === 'Closed' || status === 'PickedUp') return 'primary';
  if (status === 'Confirmed' || status === 'PartiallyPickedUp' || status === 'ReadyForPickup') return 'secondary';
  if (status === 'Sent') return 'accent';
  if (status === 'Cancelled') return 'danger';
  return 'neutral';
};
